module.exports = __webpack_public_path__ + "media/images/new/icons/twitter@2x-57e5161fb706901858c1859bdea8f2e9.png";